'use client';

import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import { utilsStyles } from '../../..';
import FaIcon from '../../icon/FaIcon/FaIcon';
import Accordion from '../Accordion/Accordion';
import styles from './ResaleProhibited.module.scss';

export interface ResaleProhibitedProps {}

function ResaleProhibited() {
  const [isOpened, setIsOpened] = useState(false);
  const componentStyles = styles;

  const toggleAccordion = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsOpened(!isOpened);
  };

  return (
    <div className={componentStyles.componentStyle}>
      <button
        type='button'
        className={`${styles.head} ${utilsStyles.textBold}`}
        onClick={(e) => toggleAccordion(e)}
        data-testid='resale-prohibited-button'
      >
        <span className={styles.headText}>
          ※獲得した景品の転売、デジタルコンテンツの無断での公開は禁止しております。
        </span>
        &nbsp;
        <span className={styles.headText}>
          {isOpened ? <FaIcon icon={faChevronUp} /> : <FaIcon icon={faChevronDown} />}
        </span>
      </button>
      <Accordion isOpened={isOpened} startHeight={0}>
        <div className={componentStyles.bodyContainer} data-testid='resale-prohibited-body'>
          <p className={componentStyles.body}>
            ・本サービスで獲得された景品をオークション等へ出品する行為、その他営利目的での転売行為は禁止しております。
            <br />
            ・本サービスで獲得された動画･画像･ボイス等のデジタルコンテンツは、出品者が著作権を有しております。無断でのSNS等での公開、譲渡、その他著作権を侵害する行為は禁止しております。
            <br />
            ・当選権利は当選者ご本人のみ有効となります。当選権利の譲渡、オークション等への出品、その他営利目的での転売は禁止しております。
            <br />
          </p>
        </div>
      </Accordion>
    </div>
  );
}

export default ResaleProhibited;
